/**
 * Hexagon Compare — isolated section module.
 * Bootstraps only [data-section-type="hexagon-compare"] containers.
 * Does not touch global cart handlers or other ATC buttons.
 */
(function (window, document) {
  'use strict';

  if (window.theme && window.theme.HexagonCompareSection) {
    return;
  }

  var LABEL_ORDER = ['SPIN', 'POI', 'FORGIVENESS', 'TOUCH', 'POWER', 'CONTROL'];

  var HexagonCompareSection = {
    instances: {},
    _clickBound: false,

    whenThemeReady: function (cb, attempt) {
      attempt = attempt || 0;
      if (window.jQuery && window.theme) {
        cb();
        return;
      }
      if (attempt < 80) {
        setTimeout(function () {
          HexagonCompareSection.whenThemeReady(cb, attempt + 1);
        }, 100);
      }
    },

    init: function () {
      var self = this;
      var start = function () {
        self._bindDelegatedClick();
        document.querySelectorAll('[data-section-type="hexagon-compare"]').forEach(function (el) {
          self.boot(el);
        });
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
      } else {
        start();
      }

      document.addEventListener('shopify:section:load', function (e) {
        if (!e.detail || !e.detail.sectionId) return;
        var el = document.querySelector(
          '[data-section-type="hexagon-compare"][data-section-id="' + e.detail.sectionId + '"]'
        );
        if (el) self.boot(el);
      });

      document.addEventListener('shopify:section:unload', function (e) {
        if (!e.detail || !e.detail.sectionId) return;
        self.teardown(e.detail.sectionId);
      });
    },

    _bindDelegatedClick: function () {
      if (this._clickBound) return;
      this._clickBound = true;
      var self = this;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-hex-atc]');
        if (!btn) return;
        var section = btn.closest('[data-section-type="hexagon-compare"]');
        if (!section) return;
        e.preventDefault();
        e.stopPropagation();
        self.whenThemeReady(function () {
          self._addToCart(btn, section);
        });
      });
    },

    boot: function (container) {
      var sectionId = container.getAttribute('data-section-id');
      if (!sectionId) return;

      if (this.instances[sectionId]) {
        this._initChart(container, sectionId);
        return;
      }

      this.instances[sectionId] = { container: container };
      this._initChart(container, sectionId);
      this._observeChart(container, sectionId);

      var self = this;
      this.whenThemeReady(function () {
        self._bindVariantSync(container, sectionId);
      });
    },

    teardown: function (sectionId) {
      var inst = this.instances[sectionId];
      if (!inst) return;
      if (inst.observer) inst.observer.disconnect();
      if (window.jQuery && inst.$mainProduct) {
        inst.$mainProduct.off('.hexCompare' + sectionId);
      }
      delete this.instances[sectionId];
    },

    _observeChart: function (container, sectionId) {
      var chartEl = container.querySelector('#hexchart-' + sectionId);
      if (!chartEl || !chartEl.parentElement || typeof MutationObserver === 'undefined') return;
      var self = this;
      var observer = new MutationObserver(function () {
        self._drawHexagon(container, sectionId);
      });
      observer.observe(chartEl.parentElement, { childList: true, subtree: true });
      this.instances[sectionId].observer = observer;
    },

    _initChart: function (container, sectionId) {
      try {
        this._positionHexLabels(container, sectionId);
        this._drawHexagon(container, sectionId);
      } catch (err) { /* chart only */ }
    },

    _positionHexLabels: function (container, sectionId) {
      var cx = 326;
      var cy = 160;
      var pad = 24;
      var verts = [
        { x: 326, y: 18 },
        { x: 449, y: 89 },
        { x: 449, y: 231 },
        { x: 326, y: 302 },
        { x: 203, y: 231 },
        { x: 203, y: 89 }
      ];

      verts.forEach(function (v, i) {
        var lbl = container.querySelector('#hexLbl' + i + '-' + sectionId);
        if (!lbl) return;
        var ang = Math.atan2(v.y - cy, v.x - cx);
        var lx = v.x + pad * Math.cos(ang);
        var ly = v.y + pad * Math.sin(ang);
        var anchor = 'middle';
        if (Math.cos(ang) > 0.35) anchor = 'start';
        else if (Math.cos(ang) < -0.35) anchor = 'end';
        lbl.setAttribute('x', lx.toFixed(1));
        lbl.setAttribute('y', ly.toFixed(1));
        lbl.setAttribute('text-anchor', anchor);
        lbl.removeAttribute('dx');
        lbl.removeAttribute('dy');
      });
    },

    _drawHexagon: function (container, sectionId) {
      var chart = container.querySelector('#hexchart-' + sectionId);
      if (!chart) return;

      this._positionHexLabels(container, sectionId);

      var dataEl1 = container.querySelector('#hexData1-' + sectionId);
      var dataEl2 = container.querySelector('#hexData2-' + sectionId);
      var attrs;
      try {
        attrs = JSON.parse(chart.dataset.attrs || '[]');
      } catch (err) {
        return;
      }
      if (!attrs.length || !dataEl1) return;

      var cx = 326;
      var cy = 160;
      var maxR = 142;
      var points1 = [];
      var points2 = [];
      var maxAttrs = Math.min(attrs.length, 6);

      for (var i = 0; i < maxAttrs; i++) {
        var attr = attrs[i];
        var score1 = parseFloat(attr.s1) || 0;
        var score2 = parseFloat(attr.s2) || 0;
        var ratio1 = score1 / 10;
        var ratio2 = score2 / 10;
        var labelName = (attr.n || '').toUpperCase();
        var labelIdx = LABEL_ORDER.indexOf(labelName);
        if (labelIdx === -1) labelIdx = i;
        var angle = (labelIdx * 60 - 90) * Math.PI / 180;
        var r1 = maxR * ratio1;
        points1.push((cx + r1 * Math.cos(angle)).toFixed(1) + ',' + (cy + r1 * Math.sin(angle)).toFixed(1));
        var r2 = maxR * ratio2;
        points2.push((cx + r2 * Math.cos(angle)).toFixed(1) + ',' + (cy + r2 * Math.sin(angle)).toFixed(1));
        var lbl = container.querySelector('#hexLbl' + labelIdx + '-' + sectionId);
        if (lbl && attr.n) lbl.textContent = attr.n;
      }

      if (points1.length) {
        dataEl1.setAttribute('points', points1.join(' '));
        dataEl1.style.display = 'block';
      }
      if (points2.length && dataEl2) {
        dataEl2.setAttribute('points', points2.join(' '));
        dataEl2.style.display = 'block';
      }
    },

    _bindVariantSync: function (container, sectionId) {
      var handle = container.getAttribute('data-product-handle');
      if (!handle || !window.jQuery) return;

      var $ = window.jQuery;
      var $main = $('[data-section-type="product"][data-handle="' + handle + '"]').first();
      if (!$main.length) return;

      var inst = this.instances[sectionId];
      inst.$mainProduct = $main;
      var self = this;

      $main.off('variantChange.hexCompare' + sectionId).on('variantChange.hexCompare' + sectionId, function (e) {
        self._updateButton(container, e.variant);
      });

      var mainSectionId = $main.attr('data-section-id');
      var select = document.getElementById('ProductSelect-' + mainSectionId);
      var productJsonEl = document.getElementById('ProductJson-' + mainSectionId);
      if (!select || !productJsonEl) return;

      try {
        var productData = JSON.parse(productJsonEl.textContent);
        var variantId = parseInt(select.value, 10);
        var variant = (productData.variants || []).find(function (v) {
          return v.id === variantId;
        });
        if (variant) self._updateButton(container, variant);
      } catch (err) { /* ignore */ }
    },

    _updateButton: function (container, variant) {
      var btn = container.querySelector('[data-hex-atc]');
      var textEl = container.querySelector('[data-hex-atc-text]');
      if (!btn) return;

      var btnText = container.getAttribute('data-btn-text') || 'ADD TO CART';
      var soldOutText = container.getAttribute('data-sold-out-text') || 'Sold out';
      var unavailableText = container.getAttribute('data-unavailable-text') || 'Unavailable';

      if (!variant) {
        btn.disabled = true;
        if (textEl) textEl.textContent = unavailableText;
        return;
      }

      btn.setAttribute('data-variant-id', variant.id);

      if (variant.available) {
        btn.disabled = false;
        btn.classList.remove('btn--sold-out');
        if (textEl) textEl.textContent = btnText;
      } else {
        btn.disabled = true;
        btn.classList.add('btn--sold-out');
        if (textEl) textEl.textContent = soldOutText;
      }
    },

    _submitViaMainPdp: function (variantId, handle, hexBtn) {
      var main = document.querySelector('[data-section-type="product"][data-handle="' + handle + '"]');
      if (!main) return false;

      var mainSectionId = main.getAttribute('data-section-id');
      var form = document.getElementById('AddToCartForm-' + mainSectionId);
      var atcBtn = document.getElementById('AddToCart-' + mainSectionId);
      var select = document.getElementById('ProductSelect-' + mainSectionId);
      if (!form || !atcBtn || !select || atcBtn.disabled) return false;

      hexBtn.classList.add('is-loading');
      var finish = function () {
        setTimeout(function () {
          hexBtn.classList.remove('is-loading');
        }, 1000);
      };

      var submit = function () {
        if (atcBtn.disabled) {
          finish();
          return;
        }
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(atcBtn);
        } else {
          atcBtn.click();
        }
        finish();
      };

      if (String(select.value) !== String(variantId)) {
        select.value = variantId;
        window.jQuery(select).trigger('change');
        setTimeout(submit, 100);
      } else {
        submit();
      }
      return true;
    },

    _addToCart: function (btn, section) {
      if (btn.disabled || btn.classList.contains('is-loading')) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var handle = section.getAttribute('data-product-handle');
      if (handle && this._submitViaMainPdp(variantId, handle, btn)) return;

      var $ = window.jQuery;
      var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url + '.js' : '/cart/add.js';

      btn.classList.add('is-loading');
      $.ajax({
        type: 'POST',
        url: addUrl,
        data: { id: variantId, quantity: 1 },
        dataType: 'json'
      })
        .done($.proxy(function (item) {
          this._onCartSuccess(item);
        }, this))
        .fail($.proxy(this._onCartError, this))
        .always(function () {
          btn.classList.remove('is-loading');
        });
    },

    _onCartSuccess: function (item) {
      var $ = window.jQuery;
      var styleCart = $('.js-mini-cart').attr('data-cartmini');
      var htmlAlert;

      if (styleCart !== 'true') {
        var htmlVariant = item.variant_title !== null ? '<i>(' + item.variant_title + ')</i>' : '';
        htmlAlert =
          '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="' +
          item.image +
          '"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">' +
          item.product_title +
          ' x ' +
          item.quantity +
          '</p>' +
          htmlVariant +
          '<div><div>';
      }

      if (window.theme && theme.miniCart) {
        theme.miniCart.generateCart();
        theme.miniCart.updateElements(true);
      }

      if (styleCart === 'true') {
        if (window.theme && theme.miniCart && theme.miniCart.openDrawer) {
          theme.miniCart.openDrawer();
        }
      } else if (window.theme && theme.alert && theme.alert.new) {
        setTimeout(function () {
          theme.alert.new(theme.strings.addToCartSuccess, htmlAlert, 3000, 'notice');
        }, 300);
      }
    },

    _onCartError: function (xhr) {
      var data;
      try {
        data = JSON.parse(xhr.responseText);
      } catch (err) {
        return;
      }
      if (data.message && window.theme && theme.alert && theme.alert.new) {
        theme.alert.new('', data.description, 3000, 'warning');
      }
    }
  };

  window.theme = window.theme || {};
  window.theme.HexagonCompareSection = HexagonCompareSection;
  HexagonCompareSection.init();
})(window, document);
